module.exports = __webpack_public_path__ + "media/images/footer-62a98c69eb80923602c6cc41fc076713.png";